import type { EscalationProfileFormValues } from './EscalationProfile.types';

export const SMS_FIELD = {
  1: 'sms_recipients_p1',
  2: 'sms_recipients_p2',
  3: 'sms_recipients_p3',
  4: 'sms_recipients_p4'
} as const satisfies Record<1 | 2 | 3 | 4, keyof EscalationProfileFormValues>;
